import { make } from 'vuex-pathify'

const state = {
  name: null,
  path: null,
  hash: null,
  query: null,
  params: null,
  fullPath: null,
  meta: null
}

const getters = make.getters(state)
const actions = make.actions(state)
const mutations = make.mutations(state)

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
